import TYPE from './storeType'

const actions ={
  //userid信息
  [TYPE.videoToken]({commit, state}, msg) {
    commit(TYPE.videoToken, msg);
  },
}

export default actions;



// WEBPACK FOOTER //
// ./src/store/actions.js